import EventEmitter from "./utils/EventEmitter";
import MediaInterventionBloc from "./MediaInterventionBloc";

export default class Newsroom extends EventEmitter {
    constructor(element) {
        super();

        this.el = element;

        this.mediaInterventionBloc = document.querySelector('.media-intervention-pushes-bloc')

        if (this.mediaInterventionBloc) {
            new MediaInterventionBloc(this.mediaInterventionBloc)
        }
    }

}
